"use client"
import React, {useState} from 'react'
import { motion } from 'framer-motion';



export default function Faq() {

    const faqs = [
        { question: "What is A-Swift?", answer: "A-Swift is a Saskatoon-based delivery platform that specializes in hyper-local deliveries for non-restaurant businesses and individuals.We offer same day delivery, real-time tracking, and integration with platforms like Facebook Marketplace to make sending and receiving packages easier and more efficient."  },
        { question: "Who can use A-Swift?", answer: "A-Swift serves both local businesses and individuals. Whether you are a small business owner looking to deliver products to your customers or an individual needing to send a package, A-Swift is here to help" },
        { question: "What types of items can I send through A-Swift?", answer: "You can send a variety of items, including packages, retail products, personal deliveries, and even items purchased from platforms like Facebook Marketplace. Please note that we do not transport illegal, hazardous, or restricted goods." },
        { question: "How do I request a delivery?", answer:"Simply download the A-Swift app or visit our website, create an account, and request a driver for your delivery. Input your pickup and delivery locations, package details, and you'll be matched with a driver who will handle your delivery." },
        { question: "How does Facebook Marketplace integration work?", answer: "Our platform integrates directly with Facebook Marketplace, allowing you to easily arrange for item pickups and deliveries from Marketplace sellers. Once you've made a purchase, you can book a driver through A-Swift to collect the item and deliver it to your address." },
        { question: "Can I track my delivery in real-time?", answer: "Yes! A-Swift offers real-time tracking for all deliveries. Once a driver has picked up your package, you can monitor its journey through our app until it reaches its destination." },
        { question: "What areas does A-Swift serve?", answer: "Currently, A-Swift operates in Saskatoon and the surrounding areas. We are working on expanding our service to other regions in the near future." },
        { question: "How much does A-Swift charge for deliveries?", answer: "Our pricing is based on the distance and weight of the package. You can view the delivery cost upfront when you request a delivery, ensuring there are no hidden fees." },
        { question: "How can local businesses partner with A-Swift?", answer: "Local businesses can sign up for our business partner program, which offers features like real-time delivery tracking, easy driver requests, and a dedicated vendor app. We also provide businesses with a free retail inventory feature to advertise their products." },
        { question: "What payment methods does A-Swift accept?", answer: "We accept multiple payment options, including credit/debit cards and other secure digital payment methods through the app." },
        { question: "What if I need to cancel or modify a delivery?", answer: "You can cancel or modify a delivery through the app before the driver picks up the package. Please note that cancellation fees may apply if the driver is already en route." },
        { question: "How do I become a driver for A-Swift?", answer: "A-Swift prioritizes safety for both drivers and customers. We conduct background checks on drivers and offer in-app messaging for secure communication. In addition, we follow local guidelines to ensure safe and hygienic deliveries" },
        {
          question: "What safety measures are in place for drivers and customers?",
          answer: "A-Swift prioritizes safety for both drivers and customers. We conduct background checks on drivers and offer in-app messaging for secure communication. In addition, we follow local guidelines to ensure safe and hygienic deliveries"
        },
        { question: "How can I contact customer support?" , answer: "You can reach our customer support team through the app, via email, or by calling our support line. We are available to assist you with any questions or issues related to your deliveries." },
        {
          question: "Is A-Swift available for large businesses or bulk deliveries?",
          answer: "Yes! We work with businesses of all sizes and can accommodate bulk deliveries or customized delivery solutions for larger businesses. Contact us to learn more about how we can support your delivery needs."
        },
      ];


      const [openIndex, setOpenIndex] = useState(null);

      const toggleFaq = (index:any) => {
        setOpenIndex(openIndex === index ? null : index);
      };

      
  return (
    <div className="max-w-[1040px] mx-auto px-5 md:px-5 lg:px-5">
    <div className="py-5">
      <h1 className="text-black sb-ac text-[30px] md:text-[50px]">FAQ</h1>
      <p className="text-[#8A8C8F] text-[12px] md:text-[16px]">
        From local deliveries to last-mile solutions,we've got you covered
      </p>
    </div>

    {faqs.map((faq, index) => (
      <div
        key={index}
        className={`px-5 py-5 my-5 rounded-[10px] ${openIndex === index ? 'bg-black text-white' : 'bg-[#f6f6f6]'}`}
        onClick={() => toggleFaq(index)}

      >
        <div className='flex flex-row justify-between'> 
        <h4 className={`sb-ac ${openIndex === index ? 'text-white' : 'text-gray-800'}`}>
              {faq.question}
            </h4>
        <img
              src={openIndex === index ? '/assets/aru.svg' : '/assets/ard.svg'}
              alt="Arrow icon"
              className="h-6 w-6 transition-transform duration-200"
            //   style={{ transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0)' }}
            />

        </div>
        {openIndex === index && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden mt-2"
            >
              <p>{faq.answer}</p>
            </motion.div>
          )}

      </div>
    ))}
  </div>
  )
}

